export default __webpack_public_path__ + "locales/pt/People.json?hash=76939911394cfdf193a72cb1e953a3ea";